import { mono } from './tokens';
import AgentPreview from '../AgentPreview';
import { TrashIcon } from '@/components/icons';

export default function CharacterHero({
  modelKey,
  onPrevModel,
  onNextModel,
  name,
  role,
  trait,
  subtitle,
  color = '#53b1fd',
  actions = null,
  onDelete = null,
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        borderRight: '1px solid rgba(255,255,255,0.06)',
        minWidth: 0,
        height: '100%',
        flex: 1,
      }}
    >
      <div style={{ flex: 1, minHeight: 0 }}>
        <AgentPreview
          modelKey={modelKey}
          onPrevModel={onPrevModel}
          onNextModel={onNextModel}
        />
      </div>
      <div style={{ padding: '10px 12px 14px', flexShrink: 0 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 6,
          }}
        >
          <div
            style={{
              ...mono,
              fontSize: 15,
              color: 'white',
              fontWeight: 600,
              lineHeight: 1.2,
              wordBreak: 'break-word',
              minWidth: 0,
            }}
          >
            {name || 'Unnamed'}
          </div>
          {onDelete && (
            <button
              onClick={onDelete}
              title="Delete agent"
              aria-label="Delete agent"
              style={{
                background: 'none',
                border: 'none',
                padding: 2,
                cursor: 'pointer',
                color: 'rgba(255,255,255,0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                transition: 'color 0.15s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = 'rgba(248,113,113,0.9)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'rgba(255,255,255,0.3)';
              }}
            >
              <TrashIcon size={12} />
            </button>
          )}
        </div>
        {role && (
          <div
            style={{
              ...mono,
              fontSize: 9,
              color: 'rgba(255,255,255,0.35)',
              marginBottom: 5,
            }}
          >
            {role}
          </div>
        )}
        {trait && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 6 }}>
            <span
              style={{
                ...mono,
                fontSize: 8,
                color,
                background: `${color}1a`,
                border: `1px solid ${color}44`,
                borderRadius: 12,
                padding: '2px 7px',
              }}
            >
              {trait}
            </span>
          </div>
        )}
        {subtitle && (
          <div
            style={{
              ...mono,
              fontSize: 9,
              color,
              opacity: 0.7,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              marginBottom: 8,
            }}
          >
            {subtitle}
          </div>
        )}
        {actions}
      </div>
    </div>
  );
}
